import { lazy, Suspense } from 'react';
import type { FC, ComponentType } from 'react';
import { Dialog, Box, CircularProgress } from '@mui/material';
import { useModalsStore, ModalType } from '@/app/store/modalsStore';

const CreateProjectModal = lazy(() =>
  import('@/features/projects/modals/CreateProjectModal').then((m) => ({ default: m.CreateProjectModal }))
);
const EditProjectModal = lazy(() =>
  import('@/features/projects/modals/EditProjectModal').then((m) => ({ default: m.EditProjectModal }))
);
const CreateElementModal = lazy(() =>
  import('@/features/elements/modals/CreateElementModal').then((m) => ({ default: m.CreateElementModal }))
);

const availableModals: Partial<Record<ModalType, ComponentType<any>>> = {
  createProject: CreateProjectModal,
  editProject: EditProjectModal,
  createElement: CreateElementModal,
};

export const Modals: FC = () => {
  const isModalOpen = useModalsStore((state) => state.isModalOpen);
  const modalType = useModalsStore((state) => state.modalType);
  const props = useModalsStore((state) => state.props);
  const closeModal = useModalsStore((state) => state.closeModal);

  const Component = modalType ? availableModals[modalType] : null;

  return (
    <Dialog
      open={isModalOpen}
      aria-labelledby={modalType === 'createElement' ? 'create-element-title' : undefined}
      onClose={closeModal}
      maxWidth="md"
      // fullWidth
      PaperProps={{
        sx: { display: 'flex', flexDirection: 'column' },
      }}
    >
      {Component && (
        <Suspense
          fallback={
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200, p: 4 }}>
              <CircularProgress size={32} />
            </Box>
          }
        >
          <Component {...props} isOpen={isModalOpen} onClose={closeModal} />
        </Suspense>
      )}
    </Dialog>
  );
};
